import {initializeApp} from 'firebase/app';
import {getMessaging, Messaging} from 'firebase/messaging';

//TODO Change to production config
const firebaseConfig = {
    apiKey: 'AIzaSyBXc754vxqNw-tPNRoUdP63TUY_vH9IL1Q',
    authDomain: 'jaaps-testproject-1b212.firebaseapp.com',
    projectId: 'jaaps-testproject-1b212',
    storageBucket: 'jaaps-testproject-1b212.appspot.com',
    messagingSenderId: '45902877696',
    appId: '1:45902877696:web:2ade62e18c85ed5e1a34e5',
    measurementId: 'G-P3NP25208D',
};

//TODO Change to production config
export const vapidKey = 'BP7lNekg3nkv_6B763AK5vL1_Wn8FKQdqKWB84sjNtLGFNmoJqVJzAopP45svEnt02kDzM2F2U56l7mx7As0nm4';

const initializeMessaging = (): Messaging | undefined => {
    try {
        const app = initializeApp(firebaseConfig);
        return getMessaging(app);
    } catch (e) {
        console.error(e);
        return undefined;
    }
};

export const messaging = initializeMessaging();
